import { HStack, VStack, Stack } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

import { OrderHistoryInput } from './components/input';
import { OrderHistoryFilters } from './components/OrderHistoryFilters';
import { OrderHistoryOrderBy } from './components/OrderHistoryOrderBy';
import { OrderHistoryRefresh } from './components/OrderHistoryRefresh';
import { OrderHistoryTable } from './components/table';
import { OrderHistoryTableProps, SearchFormData } from './constants';

interface IOrderHistoryMain extends OrderHistoryTableProps {
  handleClearSearch: () => void;
  handleSearchTerm: (data: SearchFormData) => void;
  onRefresh: () => void;
}

export const OrderHistoryMain = (props: IOrderHistoryMain) => {
  const renderTopSection = () => {
    return (
      <Stack
        direction={Utils.Responsive.PhoneTablet({ phone: 'column', tablet: 'row' })}
        alignItems={Utils.Responsive.PhoneTablet({ phone: 'normal', tablet: 'center' })}
        justifyContent={Utils.Responsive.PhoneTablet({ phone: 'normal', tablet: 'space-between' })}
        space={Utils.Responsive.PhoneTablet({ phone: 'stack.xxs', tablet: 0 })}>
        <OrderHistoryInput
          isMobile={props.isMobile}
          isLoading={props.isLoading.all || props.isLoading.more}
          handleClearSearch={props.handleClearSearch}
          handleSearchTerm={props.handleSearchTerm}
        />
        <HStack justifyContent="space-between">
          <Stack>
            <OrderHistoryRefresh
              onRefresh={props.onRefresh}
              hasSomeLoading={props.isLoading.all || props.isLoading.more}
            />
          </Stack>
          <HStack>
            <OrderHistoryOrderBy />
            <OrderHistoryFilters />
          </HStack>
        </HStack>
      </Stack>
    );
  };

  return (
    <VStack flex={1} space="stack.xxs">
      {renderTopSection()}
      <OrderHistoryTable
        isMobile={props.isMobile}
        isLoading={props.isLoading}
        data={props.data}
        searchTerm={props.searchTerm}
        listMoreOrders={props.listMoreOrders}
        hasFilter={props.hasFilter}
      />
    </VStack>
  );
};
